import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';

import { Location } from '@shared/models';
import { GeolocationService } from '@shared/services';
import { isTruthy } from '@shared/utils';

@Component({
  selector: 'mojo-multiple-location-input',
  templateUrl: './multiple-location-input.component.html',
  styleUrls: ['./multiple-location-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultipleLocationInputComponent implements OnInit {
  @Input()
  label: string;

  @Input()
  form: UntypedFormGroup;

  @Input()
  controlName: string;

  @Input()
  required = true;

  @Input()
  isMaterial = false;

  @Input()
  isRequired = false;

  locations$: Observable<Location[]>;

  constructor(public geolocationService: GeolocationService) {}

  ngOnInit(): void {
    this.locations$ = this.form
      .get(this.controlName)
      .valueChanges.pipe(startWith([]), filter(isTruthy));
  }

  addLocation({ locations }) {
    this.form.get(this.controlName).setValue(locations);
  }
}
